import React from 'react';
import classNames from 'classnames';
import { SIZES } from './constants';
import { getVisuallyHiddenStyles } from '../visually-hidden/helpers/get-visually-hidden-styles';
const VISUALLY_HIDDEN_STYLES = getVisuallyHiddenStyles();

const Toggle = ({
  name = '',
  value = '',
  size = SIZES.medium,
  checked = undefined,
  defaultChecked = undefined,
  disabled = false,
  onChange = Function.prototype,
}) => {
  const classes = classNames('ws-ui-toggle', `ws-ui-toggle--${size}`, {
    'ws-ui-toggle--disabled': disabled,
  });

  return (
    // eslint-disable-next-line yola/jsx-a11y/label-has-for
    <label className={classes}>
      <input
        checked={checked}
        className="ws-ui-toggle__input"
        defaultChecked={defaultChecked}
        disabled={disabled}
        name={name}
        onChange={onChange}
        type="checkbox"
        value={value}
        style={VISUALLY_HIDDEN_STYLES}
      />
      <span className="ws-ui-toggle__switch" />
    </label>
  );
};

export default Toggle;
